var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-control-sip" },
    [
      _c(
        "ui-form",
        {
          attrs: { valid: _vm.formValid },
          on: {
            "update:valid": function ($event) {
              _vm.formValid = $event
            },
            submit: function ($event) {
              return _vm.startSession(_vm.contact, _vm.pinCode, _vm.pinDelay)
            },
          },
        },
        [
          _c("ui-autocomplete", {
            ref: "contactInput",
            staticClass: "session-control-sip__contactSelect",
            attrs: {
              options: _vm.contactUriList,
              pattern: /^(?!(http|rtmp)s?:\/\/)/i,
              "pattern-error":
                "Invalid source address (see help page for details)",
              label: "Source address",
              placeholder: "Source video address: SIP/H.323 (URI or IP)",
            },
            on: {
              change: _vm.onContactChange,
              enter: _vm.onContactEnter,
              select: _vm.onContactSelect,
            },
            model: {
              value: _vm.contact,
              callback: function ($$v) {
                _vm.contact = $$v
              },
              expression: "contact",
            },
          }),
          _vm._v(" "),
          _c("pin-input", {
            staticClass: "session-control-sip__contactSelect__pinInput",
            attrs: { "pin-delay": _vm.pinDelay },
            on: {
              "update:pinDelay": function ($event) {
                _vm.pinDelay = $event
              },
              "update:pin-delay": function ($event) {
                _vm.pinDelay = $event
              },
            },
            model: {
              value: _vm.pinCode,
              callback: function ($$v) {
                _vm.pinCode = $$v
              },
              expression: "pinCode",
            },
          }),
          _vm._v(" "),
          _c("ui-button", {
            staticClass: "session-control-sip__streamRecordButton",
            attrs: {
              disabled:
                _vm.contact.length === 0 || !_vm.formValid || _vm.isConnecting,
              icon:
                "fas " +
                (_vm.isConnecting ? "fa-circle-notch fa-spin" : "fa-circle"),
              text: _vm.streamId !== null ? "STREAM" : "RECORD",
              large: "",
              type: "submit",
              raised: "",
              secondary: "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "session-control-sip__favorites" },
        _vm._l(_vm.favoriteList, function (item) {
          return _c("favorite-chip", {
            key: item.uri,
            attrs: {
              disabled: _vm.isConnecting,
              name: item.name,
              tooltip: _vm.getFavoriteTooltip(item),
              uri: item.uri,
              clickable: "",
            },
            on: {
              click: function ($event) {
                return _vm.startFavoriteSession($event)
              },
              edit: function ($event) {
                return _vm.editFavorite(item)
              },
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }